import { FC } from "react";

import SystemPromptInput from "./SystemPromptInput";
import EngineSelector from "./EngineSelector";

const RightColumn: FC = () => {
  return (
    <div className="rounded-lg w-full shadow-md shadow-outline-normal absolute right-0 top-0 pt-5 bg-regular md:relative md:w-[20%] h-full flex flex-col p-2">
      <p className="text-center mt-1 text-mid-gray text-md">Settings</p>
      <SystemPromptInput />
      <EngineSelector />
    </div>
  );
}

export default RightColumn;